export class CommentModel {
  constructor(data = {}) {
    Object.assign(this, data);
  }

  id: string = '';
  status?: number;
  employeeName?: string;
  employeeId?: string;
  text?: string;
  newsId?: string;
  postDate?: Date;
  parentId?: string;
  commentDate?: Date;
  childComments?: CommentModel[] = [new CommentModel()];
  edited?: boolean;
}

export class newCommentModel {
  parentId?: string;
  employeeName!: string;
  text!: string;
  languageCode!: string;
  newsId!: string;
}

export class CommentArray {
  comments: CommentModel[] = [];
  commentsAmmount?: number;
}

export class CommentFilterModel {
  Search?: string;
  PageIndex: number = 0;
  PageSize: number = 0;
  NewsId?: string;
  ParentId?: string;
  Backoffice?: boolean;
  Event?: boolean;
}
